import { render, staticRenderFns } from "./DashboardPagePopup.vue?vue&type=template&id=748fa9ba&scoped=true&"
import script from "./DashboardPagePopup.vue?vue&type=script&lang=js&"
export * from "./DashboardPagePopup.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPagePopup.vue?vue&type=style&index=0&id=748fa9ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748fa9ba",
  null
  
)

export default component.exports